import { Directive, EventEmitter, Output } from '@angular/core';

// ngUpgrade template modal.
// @Directive() with no selector is the supported way to decorate an abstract base class that
// uses Angular features (here @Output); without it the compiler reports NG2007.
@Directive()
export abstract class ModalComponent {
    @Output() close: EventEmitter<any> = new EventEmitter<any>();

    protected closeModal(result: any = false) {
        this.close.emit(result);
    };
}
